import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown, faCircleCheck } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'empathy-select-type-button',
  templateUrl: './select-type-button.component.html',
  styleUrl: './select-type-button.component.scss'
})
export class SelectTypeButtonComponent {
  @Input() active: boolean;
  @Input() disabled: boolean;
  @Input() icon: IconDefinition = faCircleCheck;
  @Input() text = '';

  @Output() action: EventEmitter<boolean> = new EventEmitter<boolean>();

  iconArrow: IconDefinition = faChevronDown;

  emitAction(): void {
    this.action.emit(true);
  }
}
